
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6be7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6be7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("01FIu", function(module, exports) {

$parcel$export(module.exports, "handleShareClick", () => $0050742cc8f2b4a1$export$1471aabd64a580f1);

var $j591w = parcelRequire("j591w");
/**
 * Share helper:
 * Two-tap UX (iOS-safe):
 * - Tap #1: generates the short URL (Firestore) and updates button label to "Copia link".
 * - Tap #2: copies the already-generated short URL to clipboard (no `await` before copy).
 */ const $0050742cc8f2b4a1$var$ICON_SHARE = 'ph ph-share-network';
const $0050742cc8f2b4a1$var$ICON_COPY = 'ph ph-copy';
const $0050742cc8f2b4a1$var$ICON_CHECK = 'ph ph-check';
function $0050742cc8f2b4a1$var$setButtonVisual(shareButton, { label: label, iconClass: iconClass } = {}) {
    const textNode = shareButton.querySelector('.button-text');
    const iconNode = shareButton.querySelector('i');
    if (iconClass) {
        if (iconNode) iconNode.className = iconClass;
        else {
            const newIcon = document.createElement('i');
            newIcon.className = iconClass;
            shareButton.prepend(newIcon);
            shareButton.insertAdjacentText('afterbegin', ' ');
        }
    }
    if (textNode) {
        if (typeof label === 'string') textNode.textContent = label;
        return;
    }
    if (iconNode) {
        if (typeof label === 'string') shareButton.innerHTML = `${iconNode.outerHTML} ${label}`;
        return;
    }
    if (typeof label === 'string') shareButton.textContent = label;
}
function $0050742cc8f2b4a1$var$fallbackCopyTextToClipboard(text) {
    try {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.top = '-1000px';
        textarea.style.left = '-1000px';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        textarea.setSelectionRange(0, textarea.value.length);
        const ok = document.execCommand('copy');
        document.body.removeChild(textarea);
        return ok;
    } catch (error) {
        return false;
    }
}
async function $0050742cc8f2b4a1$var$copyToClipboard(text) {
    try {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);
            return true;
        }
    } catch (error) {
    // fall through
    }
    const ok = $0050742cc8f2b4a1$var$fallbackCopyTextToClipboard(text);
    if (ok) return true;
    // Last resort: manual copy (does NOT auto-copy)
    window.prompt('Copia il link:', text);
    return false;
}
async function $0050742cc8f2b4a1$export$1471aabd64a580f1(shareButton, options = {}) {
    if (!shareButton) return;
    const { campaign: campaign = 'sharing_link', generatingText: generatingText = 'Generazione...', readyText: readyText = 'Copia link', copiedText: copiedText = 'Link copiato', resetAfterMs: resetAfterMs = 1500 } = options;
    if (!shareButton.dataset.shareOriginalContent) shareButton.dataset.shareOriginalContent = shareButton.innerHTML;
    const existingShortUrl = shareButton.dataset.shareShortUrl;
    const isReadyToCopy = shareButton.dataset.shareStage === 'ready' && !!existingShortUrl;
    // Tap #2: copy (iOS-safe because we don't `await` anything before choosing the text to copy)
    if (isReadyToCopy) {
        shareButton.disabled = true;
        try {
            await $0050742cc8f2b4a1$var$copyToClipboard(existingShortUrl);
            $0050742cc8f2b4a1$var$setButtonVisual(shareButton, {
                label: copiedText,
                iconClass: $0050742cc8f2b4a1$var$ICON_CHECK
            });
        } finally{
            setTimeout(()=>{
                shareButton.disabled = false;
                $0050742cc8f2b4a1$var$setButtonVisual(shareButton, {
                    label: readyText,
                    iconClass: $0050742cc8f2b4a1$var$ICON_COPY
                });
            }, resetAfterMs);
        }
        return;
    }
    // Tap #1: generate short URL (Firestore)
    shareButton.disabled = true;
    $0050742cc8f2b4a1$var$setButtonVisual(shareButton, {
        label: generatingText,
        iconClass: $0050742cc8f2b4a1$var$ICON_SHARE
    });
    try {
        const shortUrl = await (0, $j591w.createShortUrl)(window.location.href, campaign);
        shareButton.dataset.shareShortUrl = shortUrl;
        shareButton.dataset.shareStage = 'ready';
        $0050742cc8f2b4a1$var$setButtonVisual(shareButton, {
            label: readyText,
            iconClass: $0050742cc8f2b4a1$var$ICON_COPY
        });
    } catch (error) {
        console.error('Short URL creation failed', error);
        shareButton.dataset.shareStage = 'error';
        $0050742cc8f2b4a1$var$setButtonVisual(shareButton, {
            label: 'Errore, riprova',
            iconClass: $0050742cc8f2b4a1$var$ICON_SHARE
        });
        setTimeout(()=>{
            shareButton.innerHTML = shareButton.dataset.shareOriginalContent;
            delete shareButton.dataset.shareStage;
            delete shareButton.dataset.shareShortUrl;
        }, 2000);
    }
    shareButton.disabled = false;
}

});
parcelRegister("j591w", function(module, exports) {

$parcel$export(module.exports, "createShortUrl", () => $de457bdbc5c961c5$export$181919154f900a5b);
// Firestore serve solo quando l'utente condivide: si carica a quel momento,
// cosi' le pagine che importano questo modulo non pagano i 350 KB dell'SDK.


async function $de457bdbc5c961c5$var$caricaFirestore() {
    const [firestore, { firebaseInit: firebaseInit }] = await Promise.all([
        (parcelRequire("cet9q")),
        (parcelRequire("gQnFK"))
    ]);
    return {
        ...firestore,
        firebaseInit: firebaseInit
    };
}
const $de457bdbc5c961c5$var$CHARSET = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789';
// Referral UTM policy (requested):
// - utm_source=referral
// - utm_medium=referral
// - utm_campaign=sharing_link
const $de457bdbc5c961c5$var$DEFAULT_SOURCE = 'referral';
const $de457bdbc5c961c5$var$DEFAULT_MEDIUM = 'referral';
const $de457bdbc5c961c5$var$DEFAULT_CAMPAIGN = 'sharing_link';
function $de457bdbc5c961c5$var$generateShortCode(length = 6) {
    let code = '';
    for(let i = 0; i < length; i += 1)code += $de457bdbc5c961c5$var$CHARSET.charAt(Math.floor(Math.random() * $de457bdbc5c961c5$var$CHARSET.length));
    return code;
}
function $de457bdbc5c961c5$export$d0bba44cbdf15a1a(originalUrl, campaign = $de457bdbc5c961c5$var$DEFAULT_CAMPAIGN) {
    try {
        const url = new URL(originalUrl, window.location.origin);
        // Force consistent referral UTMs (overwrite any existing UTMs)
        url.searchParams.set('utm_source', $de457bdbc5c961c5$var$DEFAULT_SOURCE);
        url.searchParams.set('utm_medium', $de457bdbc5c961c5$var$DEFAULT_MEDIUM);
        url.searchParams.set('utm_campaign', campaign || $de457bdbc5c961c5$var$DEFAULT_CAMPAIGN);
        return url.toString();
    } catch (error) {
        console.error('appendShareTrackingParams failed', error);
        return originalUrl;
    }
}
async function $de457bdbc5c961c5$var$getUniqueShortCode(shortUrlsRef, { doc: doc, getDoc: getDoc }) {
    const maxAttempts = 5;
    for(let attempt = 0; attempt < maxAttempts; attempt += 1){
        const shortCode = $de457bdbc5c961c5$var$generateShortCode(6 + Math.floor(Math.random() * 3));
        const docRef = doc(shortUrlsRef, shortCode);
        const existing = await getDoc(docRef);
        if (!existing.exists()) return {
            shortCode: shortCode,
            docRef: docRef
        };
    }
    throw new Error('Unable to generate unique short code');
}
async function $de457bdbc5c961c5$export$181919154f900a5b(originalUrl, campaign = $de457bdbc5c961c5$var$DEFAULT_CAMPAIGN) {
    const trackedUrl = $de457bdbc5c961c5$export$d0bba44cbdf15a1a(originalUrl, campaign);
    const firestore = await $de457bdbc5c961c5$var$caricaFirestore();
    const { getFirestore: getFirestore, collection: collection, setDoc: setDoc, serverTimestamp: serverTimestamp, firebaseInit: firebaseInit } = firestore;
    const { app: app } = firebaseInit();
    const db = getFirestore(app);
    const shortUrlsRef = collection(db, 'shortUrls');
    const { shortCode: shortCode, docRef: docRef } = await $de457bdbc5c961c5$var$getUniqueShortCode(shortUrlsRef, firestore);
    const payload = {
        originalUrl: trackedUrl,
        shortCode: shortCode,
        baseUrl: window.location.origin,
        createdAt: serverTimestamp(),
        utm_source: $de457bdbc5c961c5$var$DEFAULT_SOURCE,
        utm_medium: $de457bdbc5c961c5$var$DEFAULT_MEDIUM,
        utm_campaign: campaign || $de457bdbc5c961c5$var$DEFAULT_CAMPAIGN
    };
    await setDoc(docRef, payload);
    const base = window.location.origin || 'https://www.stipendee.it';
    return `${base}/s/${shortCode}`;
}

});
parcelRegister("cet9q", function(module, exports) {
module.exports = Promise.all([
    import("gyHl0"),
    import("eF1tK")
]).then(()=>parcelRequire('ilpIi'));

});

parcelRegister("gQnFK", function(module, exports) {
module.exports = Promise.all([
    import("gyHl0"),
    import("jYu4x")
]).then(()=>parcelRequire('4QApW'));

});



/**
 * Calcolatore Interesse Composto
 * Real-time compound interest calculator with Chart.js visualization.
 */ 
var $01FIu = parcelRequire("01FIu");

var $eZ0we = parcelRequire("eZ0we");
// Dizionario locale del calcolatore (chiavi = stringhe italiane).
(0, $eZ0we.registerTranslations)({
    'Annuale': 'Yearly',
    'Semestrale': 'Half-yearly',
    'Trimestrale': 'Quarterly',
    'Mensile': 'Monthly',
    'Ora': 'Now',
    "Anno\xa0{y}": "Year\xa0{y}",
    'dopo {years} anni al {rate}%': 'after {years} years at {rate}%',
    'sul capitale di {amount}': 'on a principal of {amount}',
    "Mostra meno \u25B2": "Show less \u25B2",
    "Mostra tutti gli anni ({n}) \u25BC": "Show all years ({n}) \u25BC",
    'Valore reale': 'Real value',
    'Capitale totale': 'Total balance',
    'Versamenti totali': 'Total deposits',
    'Interessi maturati': 'Interest earned',
    '{n} anni': '{n} years',
    'Importo per versamento {freq}': 'Amount per {freq} contribution'
});
const $6dcf60ef0dc2a984$var$SHARE_CAMPAIGN = 'ic_sharing';
const $6dcf60ef0dc2a984$var$encodeParams = (obj)=>{
    try {
        return btoa(encodeURIComponent(JSON.stringify(obj)));
    } catch (e) {
        return null;
    }
};
const $6dcf60ef0dc2a984$var$decodeParams = (encoded)=>{
    try {
        return JSON.parse(decodeURIComponent(atob(encoded)));
    } catch (e) {
        return null;
    }
};
let $6dcf60ef0dc2a984$var$chart = null;
let $6dcf60ef0dc2a984$var$showAllRows = false;
let $6dcf60ef0dc2a984$var$allRows = [];
const $6dcf60ef0dc2a984$var$fmt = (v)=>"\u20AC\u202F" + Math.round(v).toLocaleString((0, $eZ0we.UI_LOCALE));
// Separatore decimale coerente con la lingua della pagina (7.0 -> "7,0" solo in italiano).
const $6dcf60ef0dc2a984$var$fmtDecimal = (v)=>(0, $eZ0we.PAGE_LANG) === 'en' ? v : v.replace('.', ',');
const $6dcf60ef0dc2a984$var$freqValues = [
    1,
    2,
    4,
    12
];
const $6dcf60ef0dc2a984$var$freqLabels = [
    (0, $eZ0we.t)('Annuale'),
    (0, $eZ0we.t)('Semestrale'),
    (0, $eZ0we.t)('Trimestrale'),
    (0, $eZ0we.t)('Mensile')
];
// Contribution frequency: from most frequent (monthly) to least (annual)
const $6dcf60ef0dc2a984$var$contribFreqValues = [
    12,
    4,
    2,
    1
];
const $6dcf60ef0dc2a984$var$contribFreqLabels = [
    (0, $eZ0we.t)('Mensile'),
    (0, $eZ0we.t)('Trimestrale'),
    (0, $eZ0we.t)('Semestrale'),
    (0, $eZ0we.t)('Annuale')
];
function $6dcf60ef0dc2a984$var$getFreqFromIndex(i) {
    return $6dcf60ef0dc2a984$var$freqValues[Math.max(0, Math.min(3, i))];
}
function $6dcf60ef0dc2a984$var$getContribFreqFromIndex(i) {
    return $6dcf60ef0dc2a984$var$contribFreqValues[Math.max(0, Math.min(3, i))];
}
function $6dcf60ef0dc2a984$var$updateSliderFill(el) {
    const min = parseFloat(el.min);
    const max = parseFloat(el.max);
    const val = parseFloat(el.value);
    const pct = (val - min) / (max - min) * 100;
    el.style.setProperty('--fill', pct + '%');
}
function $6dcf60ef0dc2a984$var$getInputs() {
    return {
        P: parseFloat(document.getElementById('ic-principal').value) || 0,
        r: parseFloat(document.getElementById('ic-rate').value) / 100,
        Y: parseInt(document.getElementById('ic-years').value, 10),
        m: parseFloat(document.getElementById('ic-monthly').value) || 0,
        mFreq: $6dcf60ef0dc2a984$var$getContribFreqFromIndex(parseInt(document.getElementById('ic-contrib-freq').value, 10)),
        infl: parseFloat(document.getElementById('ic-inflation').value) / 100,
        n: $6dcf60ef0dc2a984$var$getFreqFromIndex(parseInt(document.getElementById('ic-freq').value, 10))
    };
}
function $6dcf60ef0dc2a984$var$updateUrl() {
    const el = (id)=>document.getElementById(id);
    const params = {
        p: el('ic-principal').value,
        r: el('ic-rate').value,
        y: el('ic-years').value,
        m: el('ic-monthly').value,
        mf: el('ic-contrib-freq').value,
        n: el('ic-freq').value,
        i: el('ic-inflation').value
    };
    const encoded = $6dcf60ef0dc2a984$var$encodeParams(params);
    if (encoded) {
        const url = `${window.location.pathname}?d=${encoded}`;
        window.history.replaceState({}, '', url);
    }
    // Reset share button so a new short URL gets generated with updated params
    const btn = document.getElementById('ic-share-btn');
    if (btn) {
        delete btn.dataset.shareShortUrl;
        delete btn.dataset.shareStage;
    }
}
function $6dcf60ef0dc2a984$var$loadFromUrl() {
    const encoded = new URLSearchParams(window.location.search).get('d');
    if (!encoded) return;
    const p = $6dcf60ef0dc2a984$var$decodeParams(encoded);
    if (!p) return;
    const set = (id, val)=>{
        const el = document.getElementById(id);
        if (el && val !== undefined) el.value = val;
    };
    set('ic-principal', p.p);
    set('ic-rate', p.r);
    set('ic-years', p.y);
    set('ic-monthly', p.m);
    set('ic-contrib-freq', p.mf);
    set('ic-freq', p.n);
    set('ic-inflation', p.i);
}
function $6dcf60ef0dc2a984$var$calculate() {
    const { P: P, r: r, Y: Y, m: m, mFreq: mFreq, infl: infl, n: n } = $6dcf60ef0dc2a984$var$getInputs();
    // Rate per capitalization period
    const rn = r / n;
    // Effective rate per contribution period (accounts for capitalization between contributions)
    const rContrib = mFreq > 0 && r > 0 ? Math.pow(1 + rn, n / mFreq) - 1 : r / mFreq;
    const labels = [];
    const balances = [];
    const deposited = [];
    const interests = [];
    const realBalances = [];
    $6dcf60ef0dc2a984$var$allRows = [];
    for(let y = 0; y <= Y; y++){
        const periods = n * y;
        const contribPeriods = mFreq * y;
        const balance = P * Math.pow(1 + rn, periods) + (rContrib > 0 ? m * ((Math.pow(1 + rContrib, contribPeriods) - 1) / rContrib) : m * contribPeriods);
        const dep = P + m * mFreq * y;
        const int = Math.max(0, balance - dep);
        const realBalance = infl > 0 ? balance / Math.pow(1 + infl, y) : null;
        labels.push(y === 0 ? (0, $eZ0we.t)('Ora') : (0, $eZ0we.t)('Anno\u00a0{y}', {
            y: y
        }));
        balances.push(Math.round(balance));
        deposited.push(Math.round(dep));
        interests.push(Math.round(int));
        realBalances.push(realBalance !== null ? Math.round(realBalance) : null);
        if (y > 0) {
            const real = infl > 0 ? balance / Math.pow(1 + infl, y) : balance;
            $6dcf60ef0dc2a984$var$allRows.push({
                y: y,
                dep: Math.round(dep),
                int: Math.round(int),
                bal: Math.round(balance),
                real: Math.round(real)
            });
        }
    }
    const finalBal = balances[Y];
    const dep = deposited[Y];
    const int = finalBal - dep;
    const realVal = infl > 0 ? finalBal / Math.pow(1 + infl, Y) : finalBal;
    const multi = dep > 0 ? finalBal / dep : 0;
    // Update metric cards
    const rateDisplay = $6dcf60ef0dc2a984$var$fmtDecimal(parseFloat(document.getElementById('ic-rate').value).toFixed(1));
    document.getElementById('ic-r-final').textContent = $6dcf60ef0dc2a984$var$fmt(finalBal);
    document.getElementById('ic-r-final-sub').textContent = (0, $eZ0we.t)('dopo {years} anni al {rate}%', {
        years: Y,
        rate: rateDisplay
    });
    document.getElementById('ic-r-interest').textContent = $6dcf60ef0dc2a984$var$fmt(int);
    document.getElementById('ic-r-interest-sub').textContent = (0, $eZ0we.t)('sul capitale di {amount}', {
        amount: $6dcf60ef0dc2a984$var$fmt(P)
    });
    document.getElementById('ic-r-deposited').textContent = $6dcf60ef0dc2a984$var$fmt(dep);
    document.getElementById('ic-r-multi').textContent = $6dcf60ef0dc2a984$var$fmtDecimal(multi.toFixed(2)) + '\u00d7';
    document.getElementById('ic-r-real-val').textContent = $6dcf60ef0dc2a984$var$fmt(realVal);
    $6dcf60ef0dc2a984$var$renderTable($6dcf60ef0dc2a984$var$showAllRows);
    $6dcf60ef0dc2a984$var$updateLegend(infl);
    $6dcf60ef0dc2a984$var$renderChart(labels, balances, deposited, interests, realBalances, infl);
    $6dcf60ef0dc2a984$var$updateUrl();
}
function $6dcf60ef0dc2a984$var$renderTable(all) {
    const rows = all ? $6dcf60ef0dc2a984$var$allRows : $6dcf60ef0dc2a984$var$allRows.slice(0, 10);
    const tbody = document.getElementById('ic-tbody');
    tbody.innerHTML = rows.map((r)=>`
    <tr>
      <td>${r.y}</td>
      <td class="num">${$6dcf60ef0dc2a984$var$fmt(r.dep)}</td>
      <td class="num green">+${$6dcf60ef0dc2a984$var$fmt(r.int)}</td>
      <td class="num">${$6dcf60ef0dc2a984$var$fmt(r.bal)}</td>
      <td class="num muted">${$6dcf60ef0dc2a984$var$fmt(r.real)}</td>
    </tr>`).join('');
    const btn = document.getElementById('ic-show-more');
    if ($6dcf60ef0dc2a984$var$allRows.length <= 10) {
        btn.style.display = 'none';
        return;
    }
    btn.style.display = 'block';
    btn.textContent = all ? (0, $eZ0we.t)('Mostra meno \u25b2') : (0, $eZ0we.t)('Mostra tutti gli anni ({n}) \u25bc', {
        n: $6dcf60ef0dc2a984$var$allRows.length
    });
}
function $6dcf60ef0dc2a984$var$updateLegend(infl) {
    const legend = document.getElementById('ic-legend');
    const realEntry = legend.querySelector('.ic-legend-real');
    if (infl > 0 && !realEntry) {
        const span = document.createElement('span');
        span.className = 'ic-legend-real';
        span.innerHTML = '<i style="background:#a855f7;opacity:0.7"></i> ' + (0, $eZ0we.t)('Valore reale');
        legend.appendChild(span);
    } else if (infl === 0 && realEntry) realEntry.remove();
}
function $6dcf60ef0dc2a984$var$renderChart(labels, balances, deposited, interests, realBalances, infl) {
    const ctx = document.getElementById('ic-chart').getContext('2d');
    if ($6dcf60ef0dc2a984$var$chart) $6dcf60ef0dc2a984$var$chart.destroy();
    // Chart is loaded via CDN as global
    $6dcf60ef0dc2a984$var$chart = new window.Chart(ctx, {
        type: 'line',
        data: {
            labels: labels,
            datasets: [
                {
                    label: (0, $eZ0we.t)('Capitale totale'),
                    data: balances,
                    borderColor: '#214ccd',
                    backgroundColor: 'rgba(33,76,205,0.07)',
                    fill: true,
                    tension: 0.35,
                    pointRadius: 0,
                    borderWidth: 2.5
                },
                {
                    label: (0, $eZ0we.t)('Versamenti totali'),
                    data: deposited,
                    borderColor: '#f59e0b',
                    backgroundColor: 'transparent',
                    fill: false,
                    tension: 0.35,
                    pointRadius: 0,
                    borderWidth: 1.5,
                    borderDash: [
                        5,
                        4
                    ]
                },
                {
                    label: (0, $eZ0we.t)('Interessi maturati'),
                    data: interests,
                    borderColor: '#16a34a',
                    backgroundColor: 'rgba(22,163,74,0.06)',
                    fill: true,
                    tension: 0.35,
                    pointRadius: 0,
                    borderWidth: 2
                },
                ...infl > 0 ? [
                    {
                        label: (0, $eZ0we.t)('Valore reale'),
                        data: realBalances,
                        borderColor: '#a855f7',
                        backgroundColor: 'transparent',
                        fill: false,
                        tension: 0.35,
                        pointRadius: 0,
                        borderWidth: 2,
                        borderDash: [
                            4,
                            3
                        ]
                    }
                ] : []
            ]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            interaction: {
                mode: 'index',
                intersect: false
            },
            plugins: {
                legend: {
                    display: false
                },
                tooltip: {
                    backgroundColor: '#fff',
                    borderColor: '#e2e8f0',
                    borderWidth: 1,
                    titleColor: '#1a1a1a',
                    bodyColor: '#4b5563',
                    padding: 10,
                    callbacks: {
                        label: (ctx)=>' ' + ctx.dataset.label + ': ' + $6dcf60ef0dc2a984$var$fmt(ctx.parsed.y)
                    }
                }
            },
            scales: {
                x: {
                    grid: {
                        display: false
                    },
                    ticks: {
                        maxTicksLimit: 10,
                        font: {
                            size: 11,
                            family: 'Inter, -apple-system, sans-serif'
                        },
                        color: '#94a3b8'
                    }
                },
                y: {
                    grid: {
                        color: '#f1f5f9'
                    },
                    ticks: {
                        font: {
                            size: 11,
                            family: 'Inter, -apple-system, sans-serif'
                        },
                        color: '#94a3b8',
                        callback: (v)=>v >= 1000000 ? "\u20AC" + (v / 1000000).toFixed(1) + 'M' : v >= 1000 ? "\u20AC" + (v / 1000).toFixed(0) + 'k' : "\u20AC" + v
                    }
                }
            }
        }
    });
}
function $6dcf60ef0dc2a984$var$initSlider(id, displayId, formatter) {
    const el = document.getElementById(id);
    const disp = document.getElementById(displayId);
    $6dcf60ef0dc2a984$var$updateSliderFill(el);
    disp.textContent = formatter(el.value);
    el.addEventListener('input', ()=>{
        $6dcf60ef0dc2a984$var$updateSliderFill(el);
        disp.textContent = formatter(el.value);
        $6dcf60ef0dc2a984$var$calculate();
    });
}
function $6dcf60ef0dc2a984$var$init() {
    // Load URL params first so initSlider reads the correct values for fill/label
    $6dcf60ef0dc2a984$var$loadFromUrl();
    // Rate slider: 0–20%
    $6dcf60ef0dc2a984$var$initSlider('ic-rate', 'ic-rate-val', (v)=>$6dcf60ef0dc2a984$var$fmtDecimal(parseFloat(v).toFixed(1)) + '%');
    // Years slider: 1–50
    $6dcf60ef0dc2a984$var$initSlider('ic-years', 'ic-years-val', (v)=>(0, $eZ0we.t)('{n} anni', {
            n: v
        }));
    // Freq slider: 4 steps mapped to [1, 2, 4, 12]
    $6dcf60ef0dc2a984$var$initSlider('ic-freq', 'ic-freq-val', (v)=>$6dcf60ef0dc2a984$var$freqLabels[parseInt(v, 10)]);
    // Contribution frequency slider
    $6dcf60ef0dc2a984$var$initSlider('ic-contrib-freq', 'ic-contrib-freq-val', (v)=>$6dcf60ef0dc2a984$var$contribFreqLabels[parseInt(v, 10)]);
    document.getElementById('ic-contrib-freq').addEventListener('input', function() {
        const label = $6dcf60ef0dc2a984$var$contribFreqLabels[parseInt(this.value, 10)].toLowerCase();
        document.getElementById('ic-monthly-label').textContent = (0, $eZ0we.t)('Importo per versamento {freq}', {
            freq: label
        });
    });
    // Number inputs
    [
        'ic-principal',
        'ic-monthly',
        'ic-inflation'
    ].forEach((id)=>{
        document.getElementById(id).addEventListener('input', $6dcf60ef0dc2a984$var$calculate);
    });
    // Show more table toggle
    document.getElementById('ic-show-more').addEventListener('click', ()=>{
        $6dcf60ef0dc2a984$var$showAllRows = !$6dcf60ef0dc2a984$var$showAllRows;
        $6dcf60ef0dc2a984$var$renderTable($6dcf60ef0dc2a984$var$showAllRows);
    });
    // Share button
    const shareBtn = document.getElementById('ic-share-btn');
    if (shareBtn) shareBtn.addEventListener('click', ()=>(0, $01FIu.handleShareClick)(shareBtn, {
            campaign: $6dcf60ef0dc2a984$var$SHARE_CAMPAIGN
        }));
    $6dcf60ef0dc2a984$var$calculate();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $6dcf60ef0dc2a984$var$init);
else $6dcf60ef0dc2a984$var$init();


//# sourceMappingURL=compound-interest-calculator.e0fa18fa.js.map
